import { each } from '../lib/util';
import anime from 'animejs';

class HeroColorBars {
    constructor(rootEl) {
        this.rootEl = rootEl;
        this.animatedElements = this.rootEl.querySelectorAll('.color-bar, h1, h2, a');
        this.nonColorBarElements = this.rootEl.querySelectorAll('h1, h2, h3, p, a');
        this.colorBars = this.rootEl.querySelectorAll('.color-bar');
        this.headerContainer = this.rootEl.querySelector('.js-header');
        this.headings = this.headerContainer.querySelectorAll('h1, h2, h3, p');
        this.cta = this.headerContainer.querySelectorAll('a');

        this.hasResized = false;
        this.easing = 'easeOutQuad';

        this.settings = {
            duration: 600,
            easing: this.easing,
        }
        this.timeout = 2000;
        this.$bar1 = this.rootEl.querySelector('.js-bar1');
        this.$bar2 = this.rootEl.querySelector('.js-bar2');
        this.$bar3 = this.rootEl.querySelector('.js-bar3');
        this.$bar4 = this.rootEl.querySelector('.js-bar4');
        this.$bar5 = this.rootEl.querySelector('.js-bar5');
        this.$bar6 = this.rootEl.querySelector('.js-bar6');
        this.$bar7 = this.rootEl.querySelector('.js-bar7');

        this.setStartingPosition();
        setTimeout(() => {
            this.startEntryAnimation();
        }, 100);

        window.addEventListener('resize', this.resize.bind(this));
    }

    setStartingPosition() {
        this.scale = window.innerWidth / 1680;
        const padding = 15;
        each(this.headings, (heading) => {
            const style = window.getComputedStyle(heading, null).getPropertyValue('font-size');
            const lineheightStyle = window.getComputedStyle(heading, null).getPropertyValue('line-height');
            var fontSize = parseFloat(style);
            var lineHeight = parseFloat(lineheightStyle);
            heading.dataset.originalFontSize = style;
            heading.dataset.originalLineHeight = lineheightStyle;
            heading.style.fontSize = `${this.getScaledValue(fontSize)}px`;
            heading.style.lineHeight = `${this.getScaledValue(lineHeight)}px`;
        })
        each(this.colorBars, (el) => {
            const width = this.getScaledValue(el.offsetWidth);
            el.dataset.originalWidth = el.offsetWidth;
            el.style.width = `${width}px`;
            el.style.transform = `translateX(-${width + padding}px)`;
        });
        each(this.nonColorBarElements, (el) => {
            const width = el.offsetWidth;
            el.style.width = `${width}px`;
            el.style.transform = `translateX(-${width + padding}px)`;
        });
    }

    startEntryAnimation() {
        const delay = 300;
        const duration = 600;
        const margin = 20;
        each(this.colorBars, (colorbar, index) => {
            const translateXVal = this.getTranslateValue(colorbar, index);
            anime({
                targets: colorbar,
                translateX: translateXVal,
                duration: duration,
                delay: index * delay,
                easing: this.easing,
                complete: (el) => {
                    colorbar.dataset.originalTranslate = translateXVal;
                }
            })

            // animate the headers on the last color bar
            if (index === this.colorBars.length -1) {
                // h2 tags
                anime({
                    targets: this.headings,
                    translateX: translateXVal + (this.getScaledValue(margin)),
                    duration: duration,
                    delay: index * delay,
                    easing: this.easing
                })

                //cta has a delay
                anime({
                    targets: this.cta,
                    translateX: translateXVal + (this.getScaledValue(margin)),
                    duration: duration,
                    delay: index * delay + 250,
                    easing: this.easing,
                    complete: () => {
                        setTimeout(() => {
                            this.animationComplete(this.animationOne.bind(this));
                        }, this.timeout);
                    }
                })
            }
        });
    }

    animationOne() {
        console.log('animation one');

        anime({
            targets: this.$bar7,
            width: 80 * this.scale,
            ...this.settings
        });

        anime({
            targets: this.$bar6,
            translateX: `-=${this.getScaledValue(220)}`,
            width: `+=${this.getScaledValue(220)}`,
            ...this.settings
        })

        anime({
            targets: this.$bar4,
            translateX: this.rootEl.offsetWidth - this.$bar4.offsetWidth,
            ...this.settings
        });

        anime({
            targets: [this.$bar1, this.$bar2, this.$bar3],
            translateX: `-=${this.$bar4.offsetWidth}`,
            complete: () => {
                setTimeout(() => {
                    this.animationComplete(this.animationTwo.bind(this));
                }, this.timeout);
            },
            ...this.settings
        })
    }

    animationTwo() {
        console.log('animation two');
        anime({
            targets: this.$bar7,
            width: this.getScaledValue(Number(this.$bar7.dataset.originalWidth)),
            ...this.settings
        });

        anime({
            targets: this.$bar6,
            translateX: `+=${this.getScaledValue(220)}`,
            width: `-=${this.getScaledValue(220)}`,
            ...this.settings
        })

        anime({
            targets: this.$bar4,
            translateX: this.getTranslateX(this.$bar3),
            ...this.settings
        });

        anime({
            targets: [this.$bar1, this.$bar2, this.$bar3],
            translateX: `+=${this.$bar4.offsetWidth}`,
            complete: () => {
                setTimeout(() => {
                    this.animationComplete(this.animationThree.bind(this));
                }, this.timeout);
            },
            ...this.settings
        })
    }

    animationThree() {
        const bar6Width = this.getScaledValue(45);
        const line3TranslateX = this.getTranslateX(this.$bar6) + bar6Width + this.$bar5.offsetWidth;
        const line3Width = this.getTranslateX(this.$bar2) - line3TranslateX - this.$bar4.offsetWidth;

        anime({
            targets: this.$bar4,
            translateX: this.rootEl.offsetWidth - this.$bar4.offsetWidth,
            ...this.settings
        });

        anime({
            targets: this.$bar5,
            translateX: this.getTranslateX(this.$bar6) + bar6Width,
            ...this.settings
        })

        anime({
            targets: this.$bar6,
            width: bar6Width,
            ...this.settings
        })

        anime({
            targets: [this.$bar1, this.$bar2],
            translateX: `-=${this.$bar4.offsetWidth + line3Width}`,
            ...this.settings
        })

        anime({
            targets: this.$bar3,
            width: line3Width,
            translateX: this.getTranslateX(this.$bar6) + bar6Width + this.$bar5.offsetWidth + this.$bar1.offsetWidth + this.$bar2.offsetWidth,
            complete: () => {
                setTimeout(() => {
                    this.animationComplete(this.animationFour.bind(this));
                    // this.animationComplete(this.goToStartingPosition.bind(this));
                }, this.timeout);
            },
            ...this.settings
        })
    }

    animationFour() {
        console.log('animation 4');
        each(this.colorBars, (colorbar, index) => {
            const translateXVal = colorbar.dataset.originalTranslate;
            const width = colorbar.dataset.originalWidth;

            anime({
                targets: colorbar,
                translateX: translateXVal,
                width: this.getScaledValue(width),
                complete: () => {
                    if (index === this.colorBars.length-1) {
                        setTimeout(() => {
                            this.animationComplete(this.animationFive.bind(this));
                        }, this.timeout);
                    }
                },
                ...this.settings
            })
        });
    }

    animationFive() {
        console.log('animation5');
        const bar6Width = this.getScaledValue(85);
        this.$bar6.style.zIndex = '2';
        anime({
            targets: this.$bar6,
            width: bar6Width,
            translateX: this.getTranslateX(this.$bar7),
            ...this.settings
        });
        anime({
            targets: this.$bar7,
            translateX: `+=${bar6Width}`,
            width: `+=${this.getScaledValue(40)}`,
            ...this.settings
        });
        anime({
            targets: this.$bar4,
            translateX: `-=${this.$bar5.offsetWidth}`,
            ...this.settings
        });
        anime({
            targets: this.$bar5,
            translateX: `+=${this.$bar4.offsetWidth}`,
            complete: () => {
                setTimeout(() => {
                    this.animationComplete(this.goToStartingPosition.bind(this));
                }, this.timeout);
            },
            ...this.settings
        });
    }

    goToStartingPosition() {
        each(this.colorBars, (colorbar, index) => {
            const translateXVal = colorbar.dataset.originalTranslate;
            const width = colorbar.dataset.originalWidth;

            anime({
                targets: colorbar,
                translateX: translateXVal,
                width: this.getScaledValue(width),
                complete: () => {
                    if (index === this.colorBars.length-1) {
                        setTimeout(() => {
                            this.animationComplete(this.animationOne.bind(this));
                        }, this.timeout);
                    }
                },
                ...this.settings
            })
        });
    }

    resize() {
        var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)
        if (touchsupport){ // browser doesn't support touch
            return;
        }

        this.hasResized = true;
        this.rootEl.classList.add('resizing');

        if (this.resizeDelay) {
            clearTimeout(this.resizeDelay);
        }

        this.resizeDelay = setTimeout(() => {
            each(this.colorBars, (colorbar) => {
                colorbar.style.width = `${colorbar.dataset.originalWidth}px`;
                colorbar.style.transform = 'none';
            });
            setTimeout(() => {
                each(this.headings, (heading) => {
                    const fontSize = heading.dataset.originalFontSize;
                    const lineheightStyle = heading.dataset.originalLineHeight;
                    heading.style.fontSize = `${fontSize}`;
                    heading.style.lineHeight = `${lineheightStyle}`;
                })
                each(this.nonColorBarElements, (el) => {
                    el.style.width = `auto`;
                });
                setTimeout(() => {
                    this.setStartingPosition();
                    setTimeout(() => {
                        this.rootEl.classList.remove('resizing');
                        this.startEntryAnimation();
                        this.hasResized = false;
                    }, 500)
                }, 50);
            }, 500);
        }, 1000);
    }

    animationComplete(nextStep) {
        if (!this.hasResized) {
            nextStep();
        }
        else {

        }
    }

    getTranslateValue(el, indexOfEl) {
        let cumulativeWidth = 0;
        for(let i = 0; i < indexOfEl; i++) {
            const priorColorBar = this.colorBars[i];
            cumulativeWidth+= priorColorBar.offsetWidth;
        }

        return this.rootEl.offsetWidth - el.offsetWidth - cumulativeWidth;
    }

    getColorBar(number) {
        each(this.colorBars, (bar) => {
            if (bar.dataset.number ==  number) {
                return bar;
            }
        })
    }

    getTranslateX(el) {
        return Number(el.style.transform.replace(/[^\d.]/g, ''));
    }

    getScaledValue(num) {
        return Math.floor(num * this.scale);
    }
}

export default HeroColorBars;